export default __webpack_public_path__ + "static/media/401.a33f4142.png";